import { FILTER_CONFIG_NAMES } from './DataConstants';
import { isWalkthroughNotesEnabled } from './SiteSurveyUtils';

export const getWalkthroughFilterConfig = ({ filters }: { filters: any }) => {
	return [
		filters[FILTER_CONFIG_NAMES.LOCATION],
		// Note status filter only applies when walkthrough notes are enabled (mirrors the
		// row note-preview gating in WalkthroughRowDisplay), so we don't surface a filter
		// that can never match anything.
		isWalkthroughNotesEnabled() ? filters[FILTER_CONFIG_NAMES.NOTES_STATUS] : null,
		filters[FILTER_CONFIG_NAMES.CREATED_AT],
		filters[FILTER_CONFIG_NAMES.COMPLETED_AT],
	].filter(Boolean);
};
